import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedService } from 'src/app/_shared/shared.service';
import { Fce } from '../../fce';

@Component({
  selector: 's-radio-buttons',
  templateUrl: './s-radio-buttons.component.html',
  styleUrls: ['./s-radio-buttons.component.scss'],
  imports: [CommonModule, FormsModule, TranslateModule]
})
export class SRadioButtonsComponent {
  @Input() options: { text: string, value: any, disabled?: boolean }[] = [];
  @Input() model: any;
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() autoFit: boolean = true;
  @Input() color: string = "secondary";
  @Input() name: string;
  @Input() customClass: string = "";
  @Input() customOptionClass: string = "";
  @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  uuid = this.shared.getUid();

  constructor(private shared: SharedService) {
  }


  onRadioChange(value: any) {
    this.model = value;
    this.modelChange.emit(this.model);
    this.change.emit(value);
  }
  
  isEmpty() {
    return Fce.empty(this.model)
  }
}
